import React, { useState } from "react";
import MonthFilterSelect from "../../../../Component/DigitalMarketing/MonthFilter";
import { useGetLeadsServiceTypeQuery } from "../../../../Service/dashboard";

const LeadServiceType = () => {
  const [selectedServiceType, setSelectedServiceType] = useState("fertility");

  const monthOptions = [
    { value: "fertility", label: "Fertility" },
    { value: "general", label: "General" },
  ];
  const {
    data: LeadData,
    refetch,
    isLoading,
  } = useGetLeadsServiceTypeQuery(selectedServiceType, {
    refetchOnMountOrArgChange: true,
  });
  const data = [
    {
      id: "1",
      label: "Total Leads",
      count: `${LeadData?.data?.totalLeads}`,
    },
    {
      id: "2",
      label: "Leads converted ",
      count: `${LeadData?.data?.convertedLeads}`,
    },
    {
      id: "3",
      label: "Leads that needs actions ",
      count: `${LeadData?.data?.leadsNeedingAction}`,
    },
  ];
  return (
    <>
      <div className="d-flex justify-content-between">
        <div>
          <span className="dashboard-heading mb-4">Leads by Service Type</span>
        </div>
        <div>
          <MonthFilterSelect
            value={selectedServiceType}
            onChange={setSelectedServiceType}
            options={monthOptions}
          />
        </div>
      </div>
      <div className="row  ms-1 gap-3 align-items-center">
        {data?.map((d: any) => (
          <div
            className="box-count mt-3"
            key={d?.id}
            style={{ width: "200px" }}
          >
            <div>
              <span className="f-16 fw-400">{d?.label}</span>
            </div>
            <div>
              <span className="f-32 fw-600">{d?.count}</span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default LeadServiceType;
